// MODIFIED: the footer had a hardcoded light colour, so it disappeared in dark mode.
// It now uses the theme tokens and carries the checkered band as a closing flourish.
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: 'var(--surface-raised)', borderTop: '1px solid var(--border-subtle)' }}>
      {/* A checkered-flag band to close the page, drawn in CSS - no image to load */}
      <div className="cv-checkers" />
      <div className="text-center py-8 px-4 space-y-1">
        <p className="font-display font-bold tracking-tight">
          <span className="cv-strong">SPEED</span><span className="cv-accent">VAULT</span>{/* MODIFIED: renamed from CLOUD VAULT */}
        </p>
        <p className="text-sm cv-muted">Hecho con ❤️ en PFKNR — Derechos reservados @{year}</p>
      </div>
    </footer>
  );
}
